import React, { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/auth";
import { Switch } from "../ui/switch";

const OPTIONS = [
  {
    key: "session_reminders",
    title: "Southstar session reminders",
    hint: "Reminder emails about 24 hours and 1 hour before a confirmed session.",
  },
  {
    key: "message_notifications",
    title: "New message notifications",
    hint: "An email letting you know a message is waiting. Message content is never included.",
  },
];

export const EmailPreferencesSection = () => {
  const [prefs, setPrefs] = useState(null);

  useEffect(() => {
    api.get("/me/email-preferences").then(({ data }) => setPrefs(data.preferences)).catch(() => setPrefs(null));
  }, []);

  const toggle = async (key, value) => {
    const prev = prefs;
    setPrefs({ ...prefs, [key]: value });
    try {
      const { data } = await api.put("/me/email-preferences", { [key]: value });
      setPrefs(data.preferences);
      toast.success("Email preference saved");
    } catch {
      setPrefs(prev);
      toast.error("Could not save your email preference");
    }
  };

  if (!prefs) return null;
  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-8" data-testid="email-preferences">
      <h2 className="text-lg font-bold text-[#0B132B] mb-2 flex items-center gap-2">
        <Mail className="w-5 h-5 text-[#23803F]" /> Email preferences
      </h2>
      <p className="text-sm text-[#4B5563] mb-5">
        Optional emails only. Account, security, application and session-change emails are always sent.
      </p>
      <div className="space-y-3">
        {OPTIONS.map((o) => (
          <div key={o.key} className="flex items-center justify-between gap-4 rounded-xl border border-gray-100 p-4">
            <div>
              <p className="text-sm font-semibold text-[#0B132B]">{o.title}</p>
              <p className="text-xs text-[#4B5563] mt-0.5">{o.hint}</p>
            </div>
            <Switch
              checked={!!prefs[o.key]}
              onCheckedChange={(v) => toggle(o.key, v)}
              data-testid={`email-pref-${o.key}`}
              aria-label={o.title}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
